import React, { useState, useContext } from 'react'
import {
	IconSettings,
	IconChartCandleFilled,
	IconWallet,
	IconList,
	IconHistory,
	IconChartPie,
	IconHelp,
	IconBell,
	IconMenu2,
	IconX,
	IconStar,
	IconStarFilled,
	IconChevronDown,
	IconChevronUp
} from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import {
	HeaderContainer,
	HeaderButtonWrap,
	MobileMenuButton,
	MobileMenuOverlay,
	MobileMenuDrawer,
	MobileMenuHeader,
	MobileMenuContent,
	MobileMenuItem,
	MobileMenuFooter,
	MobileMenuSection,
	MobileMenuSectionTitle,
	DesktopMenu
} from './styles'
import { useHeader, useToken, useWindowDimensions } from 'app/hooks'
import { useBalance } from 'app/hooks/user/mybalance'
import { useCheckTradePage } from 'utils/ExpensiveFunction'

import HeaderButton from './HeaderButton'
import AuthHeaderMenu from './AuthHeaderMenu'
import DarkModeToggle from './DarkModeToggle'
import { ThemeContext } from 'theme/ThemeProvider'
import { CModal, CToast } from 'app/components/Common'
import { useTradeModalStore } from '../../hooks/trade/modalStore'
import { Button, Modal, Space, Tabs, message } from 'antd'
import GDeposit from './GDeposit'
import GWithdraw from './GWithdraw'
import DWList from './DWList'
import TradeList from './TradeList'
import Notice from './Notice'
import CalcList from './CalcList'
import { useTradeStore } from '../../hooks/trade/tradeStore'
import { useExchangeStore } from '../../hooks/trade/exchangeStore'
import { COINHIDE, COIN_URL, ENGONLY } from '../../constants/APIKEYS'
import useSWR from 'swr'
import API from '../../../utils/api'
import MobileToggle from './MobileToggle'
import { View, Text } from '../../../styles/reactnative'
import DerivativesHeader from '../Trade/TradeTransaction/DerivativesTransaction/DerivativesHeader'
import BtnLanguageChange from './BtnLanguageChange'
import { AppLogo, TransferModal } from '../../components'
import TicketModal from '../TicketModal'
import VersionChecker from './VersionChecker'
import MyLog from './MyLog'
import PGDeposit from './PGDeposit'
import PGWithdraw from './PGWithdraw'

const Header = ({ showSelect = false, setShowSelect = show => { } }) => {
	const { width } = useWindowDimensions()
	const {
		textw,
		cardOpacity,
		bgColor,
		stroke,
		Secondary,
		Tertiary,
		point,
		raise,
	} = useContext(ThemeContext).theme.COLORS
	const { isDarkMode, isMobile: mobilecheck } = useContext(ThemeContext)
	const navigate = useHistory()

	const { data: headerStore, change } = useHeader()

	const { data: token, mutate: mutateToken } = useToken()

	const [displayNav, setDisplayNav] = useState('none')
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
	const [economicIndicatorOpen, setEconomicIndicatorOpen] = useState(false)
	const [assetsExpanded, setAssetsExpanded] = useState(false)
	const [star1, setStar1] = useState(true)
	const [star2, setStar2] = useState(true)
	const [star3, setStar3] = useState(true)
	const { t } = useTranslation()

	const nav = (url: string) => navigate.push(url)

	const { data: tradeStore, mutate: mutateTradeStore } = useTradeStore()
	const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore()

	const { EPs } = useExchangeStore()

	const isTrade = useCheckTradePage()

	const headercheck = /iphone|ipad|ipod|android|mobile/i.test(
		navigator.userAgent?.toLowerCase()
	)

	const isMobile = mobilecheck || headercheck

	// 자산 정보
	const { data: globalBalance } = useBalance('KRW', 9)

	return (
		<>
			<VersionChecker />

			{/* Mobile Menu */}
			<MobileMenuOverlay
				isOpen={mobileMenuOpen}
				onClick={() => setMobileMenuOpen(false)}
			/>
			<MobileMenuDrawer isOpen={mobileMenuOpen}>
				<MobileMenuHeader>
					<AppLogo
						width={80}
						height={28}
						onPress={() => window.location.href = '/partner'}
					/>
					<button
						onClick={() => setMobileMenuOpen(false)}
						style={{
							background: 'transparent',
							border: 'none',
							cursor: 'pointer',
							padding: 4,
							display: 'flex',
							alignItems: 'center',
							color: textw,
						}}>
						<IconX size={24} />
					</button>
				</MobileMenuHeader>
				<MobileMenuContent>
					{token && (
						<>
							<MobileMenuSection>
								<MobileMenuSectionTitle>{t('menu')}</MobileMenuSectionTitle>
								<MobileMenuItem
									onClick={() => {
										mutateTradeStore({
											ep_id: EPs[0]?.id,
											...EPs[0],
										})
										nav('/trade/' + EPs[0]?.id)
										setMobileMenuOpen(false)
									}}>
									{t('trade')}
								</MobileMenuItem>
								<MobileMenuItem
									onClick={() => {
										mutateModalStore({
											...modalStore,
											gDeposit: true,
											gDepositType: 'PGD',
										})
										setMobileMenuOpen(false)
									}}>
									{ENGONLY ? 'PG Deposit' : '일반입금신청'}
								</MobileMenuItem>
								<MobileMenuItem
									onClick={() => {
										mutateModalStore({
											...modalStore,
											gDeposit: true,
											gDepositType: 'D',
										})
										setMobileMenuOpen(false)
									}}>
									{ENGONLY ? 'Deposit' : '수동입금신청'}
								</MobileMenuItem>
								<MobileMenuItem
									onClick={() => {
										mutateModalStore({
											...modalStore,
											gDeposit: true,
											gDepositType: 'W',
										})
										setMobileMenuOpen(false)
									}}>
									{ENGONLY ? 'Withdraw' : '출금신청'}
								</MobileMenuItem>
								<MobileMenuItem
									onClick={() => {
										mutateModalStore({
											...modalStore,
											depositList: true,
											depositType: '*',
										})
										setMobileMenuOpen(false)
									}}>
									{t('depositandwithdrawal')}
								</MobileMenuItem>
								<MobileMenuItem
									onClick={() => {
										mutateModalStore({
											...modalStore,
											tradeList: true,
										})
										setMobileMenuOpen(false)
									}}>
									{t('tradehistory')}
								</MobileMenuItem>
								<MobileMenuItem
									onClick={() => {
										mutateModalStore({
											...modalStore,
											tradepnl: true,
										})
										setMobileMenuOpen(false)
									}}>
									{t('profitandloss')}
								</MobileMenuItem>
								<MobileMenuItem
									onClick={() => {
										mutateModalStore({
											...modalStore,
											qna: true,
										})
										setMobileMenuOpen(false)
									}}>
									{t('QNA')}
								</MobileMenuItem>
							</MobileMenuSection>

							{/* 추가 메뉴 섹션 */}
							<MobileMenuSection>
								{!COINHIDE && (
									<MobileMenuItem
										onClick={() => {
											mutateModalStore({
												...modalStore,
												notice: true,
											})
											setMobileMenuOpen(false)
										}}>
										{t('notice')}
									</MobileMenuItem>
								)}
								<MobileMenuItem
									onClick={() => {
										setEconomicIndicatorOpen(true)
										setMobileMenuOpen(false)
									}}>
									경제지표
								</MobileMenuItem>

								{/* 자산 펼치기 */}
								<MobileMenuItem
									onClick={() => setAssetsExpanded(!assetsExpanded)}
									style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<span>{t('assets')}</span>
									{assetsExpanded ? <IconChevronUp size={18} /> : <IconChevronDown size={18} />}
								</MobileMenuItem>

								{assetsExpanded && (
									<View style={{
										padding: '12px 20px',
										background: stroke + '30',
										borderRadius: 8,
										margin: '8px 20px',
										gap: 12
									}}>
										{/* 자산 요약 */}
										<View style={{ marginBottom: 12 }}>
											<Text style={{ fontSize: 12, color: textw + '80', marginBottom: 4 }}>
												{t('assetsOverview')}
											</Text>
											<View style={{ flexDirection: 'row', alignItems: 'baseline', marginTop: 8 }}>
												<Text style={{ fontSize: 18, fontWeight: 600, color: textw }}>
													{globalBalance?.balance ? Number(globalBalance.balance).toFixed(0) : '0'}
												</Text>
												<Text style={{ fontSize: 13, color: textw + '80', marginLeft: 6 }}>
													원
												</Text>
											</View>
										</View>

										{/* 버튼들 */}
										<View style={{ flexDirection: 'row', gap: 8, marginTop: 8 }}>
											<View
												onClick={() => {
													mutateModalStore({
														...modalStore,
														gDeposit: true,
														gDepositType: 'D',
													})
													setMobileMenuOpen(false)
												}}
												style={{
													flex: 1,
													padding: '10px 16px',
													borderRadius: 6,
													border: '1px solid ' + point,
													background: 'transparent',
													cursor: 'pointer',
													textAlign: 'center',
													color: point,
													fontSize: 13,
													fontWeight: 500,
													transition: 'all 0.2s ease'
												}}>
												{t('deposit')}
											</View>
											<View
												onClick={() => {
													mutateModalStore({
														...modalStore,
														gDeposit: true,
														gDepositType: 'W',
													})
													setMobileMenuOpen(false)
												}}
												style={{
													flex: 1,
													padding: '10px 16px',
													borderRadius: 6,
													background: point,
													cursor: 'pointer',
													textAlign: 'center',
													color: '#fff',
													fontSize: 13,
													fontWeight: 500,
													transition: 'all 0.2s ease'
												}}>
												{t('withdraw')}
											</View>
										</View>
									</View>
								)}
							</MobileMenuSection>
						</>
					)}
				</MobileMenuContent>
				<MobileMenuFooter>
					<View style={{ display: 'flex', flexDirection: 'row', gap: 12, justifyContent: 'space-around', alignItems: 'center' }}>
						<MobileToggle />
						<DarkModeToggle />
						{!ENGONLY && <BtnLanguageChange label={'Language'} />}
					</View>
					{token && isTrade && (
						<View
							style={{
								cursor: 'pointer',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								padding: 10,
								borderRadius: 6,
								background: point + '15',
								transition: 'all 0.15s ease',
							}}
							onClick={() => {
								mutateModalStore({
									...modalStore,
									settings: true,
								})
								setMobileMenuOpen(false)
							}}>
							<View style={{ display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center' }}>
								<IconSettings size={18} style={{ color: point }} />
								<span style={{ color: point, fontWeight: 500, fontSize: 14 }}>{t('settings')}</span>
							</View>
						</View>
					)}
				</MobileMenuFooter>
			</MobileMenuDrawer>

			<Modal
				open={headerStore?.logmodal}
				onCancel={() =>
					change({
						logmodal: false,
					})
				}
				title={t('log')}
				footer={null}
				width={900}>
				<MyLog />
			</Modal>

			{/* 경제지표 모달 */}
			<Modal
				title={
					<View
						style={{
							flexDirection: 'column',
							width: '100%',
							justifyContent: 'center',
							flex: 1,
							alignItems: 'center',
							paddingInline: '1rem',
						}}>
						경제지표
						<View
							style={{
								flexDirection: 'row',
								flex: 1,
								width: '100%',
							}}>
							<Button
								type={undefined}
								style={{ width: 100 }}
								icon={
									star1 ? (
										<>
											<IconStarFilled
												size={20}
												style={{ color: '#ffcc00' }}
											/>
											<IconStar size={20} />
											<IconStar size={20} />
										</>
									) : (
										<>
											<IconStarFilled
												size={20}
												style={{ color: '#cdcdcd' }}
											/>
											<IconStar size={20} />
											<IconStar size={20} />
										</>
									)
								}
								onClick={() => setStar1(!star1)}
							/>
							<Button
								type={undefined}
								style={{ width: 100 }}
								icon={
									star2 ? (
										<>
											<IconStarFilled
												size={20}
												style={{ color: '#ffcc00' }}
											/>
											<IconStarFilled
												size={20}
												style={{ color: '#ffcc00' }}
											/>
											<IconStar size={20} />
										</>
									) : (
										<>
											<IconStarFilled
												size={20}
												style={{ color: '#cdcdcd' }}
											/>
											<IconStarFilled
												size={20}
												style={{ color: '#cdcdcd' }}
											/>
											<IconStar size={20} />
										</>
									)
								}
								onClick={() => setStar2(!star2)}
							/>
							<Button
								type={undefined}
								style={{ width: 100 }}
								icon={
									star3 ? (
										<>
											<IconStarFilled
												size={20}
												style={{ color: '#ffcc00' }}
											/>
											<IconStarFilled
												size={20}
												style={{ color: '#ffcc00' }}
											/>
											<IconStarFilled
												size={20}
												style={{ color: '#ffcc00' }}
											/>
										</>
									) : (
										<>
											<IconStarFilled
												size={20}
												style={{ color: '#cdcdcd' }}
											/>
											<IconStarFilled
												size={20}
												style={{ color: '#cdcdcd' }}
											/>
											<IconStarFilled
												size={20}
												style={{ color: '#cdcdcd' }}
											/>
										</>
									)
								}
								onClick={() => setStar3(!star3)}
							/>
						</View>
					</View>
				}
				open={economicIndicatorOpen}
				footer={null}
				width={700}
				onCancel={() => {
					setEconomicIndicatorOpen(false)
				}}>
				<View
					dangerouslySetInnerHTML={{
						__html: `<iframe src="https://sslecal2.forexprostools.com?columns=exc_flags,exc_currency,exc_importance,exc_actual,exc_forecast,exc_previous&importance=${(
							(star1 ? '1,' : '') +
							(star2 ? '2,' : '') +
							(star3 ? '3' : '')
						).replace(
							/,\s*$/,
							''
						)}&features=datepicker,timeselector&countries=110,43,17,42,5,178,32,12,26,36,4,72,10,14,48,35,37,6,122,41,22,11,25,39&calType=day&timeZone=88&lang=18" width="650" height="467" frameborder="0" allowtransparency="true" marginwidth="0" marginheight="0"></iframe>`,
					}}></View>
			</Modal>
			<HeaderContainer
				background={bgColor}
				style={{
					height: isTrade ? 50 : 54,
					borderBottom: '1px solid ' + stroke,
				}}>
				<HeaderButtonWrap display={displayNav}>
					{/* Left Side */}
					<View
						style={{
							flexDirection: 'row',
							justifyContent: 'flex-start',
							alignItems: 'center',
							gap: 12,
							flex: 1,
						}}>
						{/* Hamburger Menu (Mobile only) */}
						{token && width < 768 && (
							<MobileMenuButton onClick={() => setMobileMenuOpen(true)}>
								<IconMenu2 size={24} />
							</MobileMenuButton>
						)}
						<DesktopMenu>
							파트너페이지
						</DesktopMenu>
					</View>

					{/* Center - Logo */}
					<View
						style={{
							flexShrink: 0,
							display: 'flex',
							alignItems: 'center',
							justifyContent: width < 768 ? 'flex-start' : 'center',
						}}>
						<AppLogo
							width={width < 768 ? 80 : 100}
							height={width < 768 ? 28 : 35}
							style={{
								cursor: 'pointer',
							}}
							onPress={() => {
								window.location.href = '/partner'
							}}
						/>
					</View>

					{/* Right Side - Profile Menu */}
					<View
						style={{
							flexDirection: 'row',
							justifyContent: 'flex-end',
							alignItems: 'center',
							gap: 8,
							flex: 1,
						}}>
						{!token && !COINHIDE && (
							<Space.Compact size="small">
								<Button
									type="default"
									size={'small'}
									onClick={() => {
										window.location.href =
											COIN_URL +
											'?ssotoken=' +
											token +
											'&darkmode=' +
											(isDarkMode ? 'dark' : 'light')
									}}
									style={{
										background: !isDarkMode
											? '#121212'
											: '#f6f6f6',
										color: !isDarkMode
											? '#AEAEAE'
											: '#828282',
										border: '1px solid #AEAEAE',
									}}>
									{t('COINFUTURES')}
								</Button>
								<Button
									type="primary"
									size={'small'}
									style={{
										background: !isDarkMode
											? '#2675AE'
											: '#2675AE',
									}}
									onClick={() => {
										window.location.href = '/'
										setShowSelect(false)
									}}>
									{t('GLOBAL')}
								</Button>
							</Space.Compact>
						)}

						{token ? <AuthHeaderMenu width={width} /> : null}

						{token && width >= 768 && (
							<View
								style={{
									width: 1,
									height: 20,
									backgroundColor: stroke,
									opacity: 0.3,
								}}>
							</View>
						)}

						{width >= 768 && (
							<>
								<MobileToggle />
								<DarkModeToggle />
								{!ENGONLY && <BtnLanguageChange label={'Language'} />}
							</>
						)}

						{token && isTrade && width >= 768 && (
							<View
								style={{
									cursor: 'pointer',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									padding: 6,
									borderRadius: 6,
									transition: 'all 0.15s ease',
								}}
								onClick={() => {
									mutateModalStore({
										...modalStore,
										settings: true,
									})
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor = point + '20'
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor = 'transparent'
								}}>
								<IconSettings
									size={18}
									style={{ color: point }}
								/>
							</View>
						)}
					</View>
				</HeaderButtonWrap>

				<CModal
					visible={modalStore?.transferModal}
					onClose={() => {
						mutateModalStore({
							...modalStore,
							transferModal: false,
						})
					}}>
					<TransferModal
						setShowModal={value => {
							mutateModalStore({
								...modalStore,
								transferModal: value,
							})
						}}
					/>
				</CModal>
				<CToast />
			</HeaderContainer>

			<CToast />

			<Modal
				open={modalStore?.settings}
				rootClassName={'modal' + (isDarkMode ? 'light' : 'dark')}
				bodyStyle={{ backgroundColor: cardOpacity, borderRadius: 10 }}
				title={t('settings')}
				onCancel={() =>
					mutateModalStore({ ...modalStore, settings: false })
				}
				onOk={() =>
					mutateModalStore({ ...modalStore, settings: false })
				}
				width={670}
				footer={null}
				centered={false}>
				<DerivativesHeader />
			</Modal>

			<Modal
				open={modalStore?.gDeposit && token}
				title={t('Deposit/withdrawal application')}
				onCancel={() =>
					mutateModalStore({ ...modalStore, gDeposit: false })
				}
				onOk={() =>
					mutateModalStore({ ...modalStore, gDeposit: false })
				}
				width={910}
				footer={null}
				centered={true}>
				<Tabs
					activeKey={modalStore?.gDepositType}
					onChange={key =>
						mutateModalStore({ ...modalStore, gDepositType: key })
					}>
					<Tabs.TabPane tab="일반입금" key="PGD">
						<PGDeposit />
					</Tabs.TabPane>
					{/* <Tabs.TabPane tab="일반출금" key="PGW">
						<PGWithdraw />
					</Tabs.TabPane> */}
					<Tabs.TabPane tab="수동입금" key="D">
						<GDeposit />
					</Tabs.TabPane>
					<Tabs.TabPane tab="출금" key="W">
						<GWithdraw />
					</Tabs.TabPane>
				</Tabs>
			</Modal>

			<Modal
				open={modalStore?.depositList && token}
				title={t('depositandwithdrawal')}
				onCancel={() =>
					mutateModalStore({ ...modalStore, depositList: false })
				}
				onOk={() =>
					mutateModalStore({ ...modalStore, depositList: false })
				}
				width={'80%'}
				footer={null}
				centered={true}>
				<DWList />
			</Modal>
			{/* Soe Thet */}
			<Modal
				open={modalStore?.tradeList && token}
				title={t('tradehistory')}
				// transitionName={'fade'}
				// maskClosable={true}
				// maskTransitionName="fade"
				destroyOnClose={true}
				onCancel={() =>
					mutateModalStore({ ...modalStore, tradeList: false })
				}
				onOk={() =>
					mutateModalStore({ ...modalStore, tradeList: false })
				}
				width={'95%'}
				bodyStyle={{ maxHeight: '95%', height: '95%' }}
				footer={null}
				centered={true}>
				<TradeList />
			</Modal>

			<Modal
				open={modalStore?.tradepnl}
				title={t('profitandloss')}
				onCancel={() =>
					mutateModalStore({ ...modalStore, tradepnl: false })
				}
				onOk={() =>
					mutateModalStore({ ...modalStore, tradepnl: false })
				}
				width={'80%'}
				footer={null}
				centered={true}>
				<CalcList />
			</Modal>

			<TicketModal />

			<Modal
				open={modalStore?.notice}
				rootClassName={'modal light'}
				title={t('notice')}
				onCancel={() =>
					mutateModalStore({ ...modalStore, notice: false })
				}
				onOk={() => mutateModalStore({ ...modalStore, notice: false })}
				width={'60%'}
				footer={null}
				centered={true}>
				<Notice />
			</Modal>
		</>
	)
}

export default React.memo(Header)
